import React, { useEffect } from 'react';
import axios from 'axios';


export default function Logout() {
useEffect(() => {
axios.post('/authapi/logout.php')
.then(() => window.location.href = '/')
.catch(() => window.location.href = '/');
}, []);


return null;
}